import Monke from "../../img/2025/Fugo.jpeg";
const Puzzle3 = () => {
  return (
    <main style={{ padding: 24 }}>
      <h1>🔥 3. Fugo der Feurige – Das Temperaturrätsel</h1>

      <p>
        Ha! Ich bin Fugo, der Feurige! Bei mir wird’s heiß – im Kopf und im
        Herz. Wenn du mein Rätsel nicht löst, verbrennst du dich an deinem
        eigenen Stolz!
      </p>
      <img src={Monke} style={{ maxWidth: "100%", marginBottom: "32px" }} />
      <p>
        <b style={{ fontSize: "1.2em" }}>
          Was ist heißer als heiß, doch wird kälter, je länger es brennt?
          <ol>
            <li>Ofen</li>
            <li>Kerze</li>
            <li>Wärmepilz</li>
            <li>Deine Mutter</li>
          </ol>
        </b>
      </p>
      <p>
        Frugo hat schon nach dir gefragt. Schau bei den Früchten mal vorbei.
      </p>
    </main>
  );
};

export default Puzzle3;
